{
    "Profile_Dwellings_HeatingSystem.heatingSystem": "FR: Heating System",
    "Profile_Dwellings_HeatingSystem.heatingSystemDetails": "FR: Heating System Details",
    "Profile_Dwellings_HeatingSystem.type": "FR: Type",
    "Profile_Dwellings_HeatingSystem.fuelType": "FR: Fuel Type",
    "Profile_Dwellings_HeatingSystem.numberOfChords": "FR: Number of Chords",
    "Profile_Dwellings_HeatingSystem.chimneyType": "FR: Chimney Type",
    "Profile_Dwellings_HeatingSystem.oilTankYear": "FR: Oil Tank Year",
    "Profile_Dwellings_HeatingSystem.oilTankLocation": "FR: Oil Tank Location",
    "Profile_Dwellings_HeatingSystem.year": "FR: Year",
    "Profile_Dwellings_HeatingSystem.primary": "FR: Primary",
    "Profile_Dwellings_HeatingSystem.renovationType": "FR: Renovation Type",
    "Profile_Dwellings_HeatingSystem.renovationYear": "FR: Renovation Year"
}
